import React, { useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

const EVENT_TYPES = ["Wedding", "Reception", "Engagement", "Birthday", "Anniversary", "Corporate Event", "Conference", "Product Launch", "Private Party", "Kitty Party", "Bulk / Daily Meals", "Other"];
const MEAL = ["Non-Vegetarian", "Mixed (Veg + Non-Veg)", "Vegetarian"];
const SERVICE = ["Buffet", "Plated", "Live Counters", "Food Stations", "Packed Meals", "Corporate Meals", "Bulk Food"];
const BUDGET = ["Under ₹500/plate", "₹500 – ₹1000/plate", "₹1000 – ₹2000/plate", "₹2000+/plate", "Discuss"];

export default function EnquiryForm({ preset = {}, compact = false, onDone }) {
  const [form, setForm] = useState({
    name: "", phone: "", email: "", event_type: "", event_date: "", guests: "",
    location: "", cuisine: "Indian Non-Veg", meal_preference: "Non-Vegetarian",
    budget: "", service_type: "", message: "", ...preset,
  });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading"); setError("");
    try {
      await api.post("/public/enquiry", { ...form, ...preset });
      setStatus("done");
      onDone && onDone();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Failed to submit.");
      setStatus("idle");
    }
  };

  if (status === "done") {
    return (
      <div className="text-center py-14 px-6" data-testid="enquiry-success">
        <CheckCircle2 className="w-16 h-16 text-gold mx-auto mb-5" />
        <h3 className="font-serif text-3xl text-burgundy mb-3">Thank You</h3>
        <p className="text-charcoal/70 max-w-md mx-auto">
          Thank you for contacting Foodie Connect Caterer. Our team will get in touch with you shortly.
        </p>
      </div>
    );
  }

  const inputCls = "w-full bg-white border border-gold/25 rounded-lg px-4 py-3 text-sm text-charcoal placeholder:text-charcoal/40 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/40 transition";
  const selCls = inputCls + " appearance-none";

  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid="enquiry-form">
      <input required placeholder="Full Name *" value={form.name} onChange={set("name")} className={inputCls} data-testid="enq-name" />
      <input required placeholder="Phone *" value={form.phone} onChange={set("phone")} className={inputCls} data-testid="enq-phone" />
      <input type="email" placeholder="Email" value={form.email} onChange={set("email")} className={inputCls} data-testid="enq-email" />
      <select value={form.event_type} onChange={set("event_type")} className={selCls} data-testid="enq-event-type">
        <option value="">Event Type</option>
        {EVENT_TYPES.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <input type="date" value={form.event_date} onChange={set("event_date")} className={inputCls} data-testid="enq-date" />
      <input placeholder="Number of Guests" value={form.guests} onChange={set("guests")} className={inputCls} data-testid="enq-guests" />
      {!compact && <input placeholder="Event Location" value={form.location} onChange={set("location")} className={inputCls} data-testid="enq-location" />}
      {!compact && <input placeholder="Cuisine Preference" value={form.cuisine} onChange={set("cuisine")} className={inputCls} data-testid="enq-cuisine" />}
      <select value={form.meal_preference} onChange={set("meal_preference")} className={selCls} data-testid="enq-meal">
        <option value="">Meal Preference</option>
        {MEAL.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <select value={form.service_type} onChange={set("service_type")} className={selCls} data-testid="enq-service">
        <option value="">Service Type</option>
        {SERVICE.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <select value={form.budget} onChange={set("budget")} className={selCls + " sm:col-span-2"} data-testid="enq-budget">
        <option value="">Budget Range</option>
        {BUDGET.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <textarea placeholder="Tell us about your occasion..." value={form.message} onChange={set("message")} rows={compact ? 2 : 4} className={inputCls + " sm:col-span-2"} data-testid="enq-message" />
      {error && <p className="sm:col-span-2 text-destructive text-sm" data-testid="enq-error">{error}</p>}
      <button type="submit" disabled={status === "loading"} className="btn-gold sm:col-span-2 justify-center" data-testid="enq-submit">
        {status === "loading" ? <><Loader2 className="w-4 h-4 animate-spin" /> Submitting...</> : "REQUEST CATERING QUOTE"}
      </button>
    </form>
  );
}
